interface IState {
    isOpen: boolean
}

const initialState: IState = {
    isOpen: false,
}

export const TOGGLE_HELP_DOCUMENT = 'TOGGLE_HELP_DOCUMENT'

function helpDocument(
    state: IState = initialState,
    action: { type: string; payload: boolean },
): IState {
    switch (action.type) {
        case TOGGLE_HELP_DOCUMENT:
            return {
                isOpen: !state.isOpen,
            }
        default:
            return state
    }
}
export default helpDocument
